import { call, put } from 'redux-saga/effects';
import { fetchLevelsFailure, fetchLevelsSuccess } from 'src/features/resources-assignment/slice';
import { GET, getHeaders } from 'src/services/ApiService';

export function* getLevels(action) {
    const { activeConnectedAppId } = action.payload;
    const url = `/iambff/v1/connected-apps/${activeConnectedAppId}/corporate-structure/levels`;

    const result = yield call(GET, url, getHeaders());

    if (result.isSuccess) {
        yield put(fetchLevelsSuccess(result.response));
    } else {
        yield put(fetchLevelsFailure('Unable to fetch levels. Link your containers to levels.'));
    }
}
